module.exports = __webpack_public_path__ + "static/media/2.88e22684.png";